
import { Link } from 'react-router-dom';

export default function DealershipInvestment() {
  const packages = [
    {
      name: 'Starter Dealership',
      price: '$50,000',
      description: 'Perfect for new entrepreneurs',
      features: [
        '2 Geo Domes + 1 Safari Tent',
        'Basic POS & Booking System',
        'Marketing Starter Kit',
        '2-Week Training Program',
        'Territory Rights (50-mile radius)'
      ],
      color: 'emerald',
      link: '/dealership/starter'
    },
    {
      name: 'Growth Dealership',
      price: '$100,000',
      description: 'Most popular choice',
      features: [
        '4 Geo Domes + 2 Safari Tents + 1 Tiny Home',
        'Advanced POS & Booking System',
        'Complete Marketing Package',
        '4-Week Training Program',
        'Territory Rights (100-mile radius)',
        'Solar Power Systems'
      ],
      color: 'blue',
      popular: true,
      link: '/dealership/growth'
    },
    {
      name: 'Premium Dealership',
      price: '$200,000',
      description: 'For established business leaders',
      features: [
        '6 Geo Domes + 4 Safari Tents + 2 Tiny Homes',
        'Enterprise POS & Booking System',
        'Premium Marketing & Advertising Package',
        '6-Week Comprehensive Training',
        'Territory Rights (200-mile radius)',
        'Complete Solar Power Systems',
        'Glamping Pods & Luxury Amenities'
      ],
      color: 'purple',
      link: '/dealership/premium'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Investment Packages</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose the dealership package that fits your business goals and investment capacity
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {packages.map((pkg, index) => (
            <div
              key={index}
              className={`relative bg-white rounded-2xl shadow-lg p-8 ${
                pkg.popular ? 'ring-2 ring-blue-500 transform scale-105' : ''
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <div className={`text-4xl font-bold text-${pkg.color}-600 mb-2`}>{pkg.price}</div>
                <p className="text-gray-600">{pkg.description}</p>
              </div>

              <ul className="space-y-4 mb-8">
                {pkg.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <i className={`ri-check-line text-${pkg.color}-500 mr-3 mt-1 flex-shrink-0`}></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <Link
                to={pkg.link}
                className={`w-full bg-${pkg.color}-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-${pkg.color}-700 transition-colors text-center block whitespace-nowrap`}
              >
                Apply for {pkg.name}
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            All packages include comprehensive support, training, and ongoing assistance
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center text-blue-600 hover:text-blue-7 font-semibold"
          >
            Have questions? Contact our team
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
